<template>
  <b-modal id="logoutModal" ref="logoutModal" hide-footer hide-header centered>
    <h3 class="text-center">Вы уверены, что хотите выйти?</h3>
    <div class="d-flex justify-content-center">
      <button class="btn btn-primary mr-2" @click="logOut()" data-dismiss="modal">Да</button>
      <button class="btn btn-primary" @click="hideModal">Нет</button>
    </div>
  </b-modal>
</template>
<script>
  import {mapMutations} from 'vuex';

  export default {
    name: "LogoutModal",
    methods: {
      ...mapMutations({
        AUTH: 'profile/AUTH'
      }),
      hideModal() {
        this.$refs['logoutModal'].hide()
      },
      logOut() {
        localStorage.clear();
        this.AUTH(false);
        this.hideModal();
        this.$router.push('/login');
      }
    }
  }
</script>

<style scoped>

</style>
